import { MatButton } from 'components/buttons'
import { Icon } from 'hello-design-system'

const VideoLightIconButton: React.FC<{
    active: boolean
    onClick: React.MouseEventHandler<HTMLButtonElement>
    alert: boolean
}> = ({ active, onClick, alert }) => (
    <MatButton
        id='video-light-icon-button'
        onClick={onClick}
        variant='contained'
        className={`${active ? 'button-in-active' : ''}`}
        color={alert ? 'warning' : 'primary'}
        width='56px'
        height='48px'
        borderRadius='48px'
    >
        <Icon iconName={active ? 'VideocamRounded' : 'VideocamOffRounded'} />
    </MatButton>
)
export { VideoLightIconButton }
